import TagSelectorContainer from "./TagSelectorContainer";

export default TagSelectorContainer;
